/**
 * ExceptionalWorkingDayDateEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
import { ExceptionalWorkingDayDateEntity } from "../ExceptionalWorkingDayDateEntity";
declare global {
    interface EntityTypeMap {
        ExceptionalWorkingDayDate: ExceptionalWorkingDayDateEntity;
    }
}
export abstract class ExceptionalWorkingDayDateGeneratedEntity extends BaseEntity {
    public abstract exceptionalWorkingDayDateId: string;
    public abstract templateId: string | null;
    public abstract date: Date;
    public abstract calendarModification: CalendarModificationEntity;
}
